import { Component, computed, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { AudioVideoCheckSelectors } from 'src/app/features/av-check/store/selectors';
import { CheckInActions } from 'src/app/features/check-in/store/actions';
import { PackageUsersSelectors } from 'src/app/features/package-users';

import { SessionHandoffActions } from '../../store/actions';
import { getAssociatedUsers } from '../../store/selectors/session-handoff.selectors';

@Component({
  selector: 'app-welcome-page-v2',
  templateUrl: './welcome-page-v2.component.html',
  styleUrls: ['./welcome-page-v2.component.scss'],
  standalone: false,
})
export class WelcomePageV2Component implements OnInit {
  private readonly needsAvCheck = this.store.selectSignal(
    AudioVideoCheckSelectors.getDoesAvCheckNeedToBeCompletedInSession
  );
  private readonly participants = this.store.selectSignal(
    PackageUsersSelectors.selectNonSigningAgentsWithFullNames
  );
  private readonly associatedUsers = this.store.selectSignal(getAssociatedUsers);

  continueButtonText = computed(() =>
    this.needsAvCheck() ? 'Set up your device' : 'Join notary session'
  );

  hasAssociatedUsers = computed(() => {
    const participants = this.participants() ?? [];
    const associated: string[] = this.associatedUsers() ?? [];

    return associated.some((associatedGuid) =>
      participants.some((p) => p.packageUserGuid.toLowerCase() === associatedGuid.toLowerCase())
    );
  });

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(CheckInActions.NonSigningAgentWelcomePageOpened());
    this.store.dispatch(SessionHandoffActions.ActivateSessionHandoff());
  }

  onParticipantJoined(packageUserGuid: string): void {
    this.store.dispatch(SessionHandoffActions.JoinSession({ payload: { packageUserGuid } }));
  }

  onContinue(): void {
    this.store.dispatch(SessionHandoffActions.ContinueToSession());
  }
}
